<template>
	<section>
		<div class="shadow-box section-content" :class="{'with-shadow' : !$mq.isDesktop()}">
			<h2>Il nostro ricettario</h2>
			<template v-if="!loading">
				<progressive-image
					:src="recipe.images.small ? recipe.images.small : recipe.images.big"
					:ratioWidth="2"
					:ratioHeight="1"
				/>
				<div
					class="label"
					v-html="`Se ti mancano idee su cosa fare per cena butta un occhio qui`"
				/>

				<router-link :to="{ name: 'cookbook' }">
					<CTA
						:content="`Vai al ricettario`"
						:size="`small`"
					/>
				</router-link>
			</template>
			<loading-placeholder v-if="loading" />
		</div>
	</section>
</template>

<script>
import { AllRecipesApi } from '../../api/AllRecipesApi'
import { RecipeApi } from '../../api/RecipeApi'

import CTA from '../Elements/CTA'

export default {
	data () {
		return {
			recipe: null,
			collectionN: 1,
			recipeId: null
		}
	},

	components: {
		CTA
	},

	computed: {
		loading () {
			return !this.recipe
		}
	},

	methods: {
        load() {
        	this.getLastRecipeId()
            
            .then(response => {
            	this.loadRecipe()
            }).catch(response => {

            })
        },

        getLastRecipeId () {
        	var rmm = new AllRecipesApi()
        	return rmm.get({
        		params: {
	                show: this.collectionN,
	                page: 1,
	                sort_direction: 'desc'
	            }
            }).then(response => {
                var recipes = response.body.data.resources
                this.recipeId = recipes[0].id
            })
        },

        retry () {
        	return this.loadRecipe()
        },

        loadRecipe () {
        	var rm = new RecipeApi() 
		    return rm.recipe(this.random())
            .then(response => {
	        	this.recipe = response.body.data.resource
	        }).catch(response => {
	        	this.retry()
	        })
        },

        random () {
        	var id = this.recipeId - Math.floor(Math.random() * Math.floor(100))
        	return id > 0 ? id : 1
        }
	},

	mounted () {
		this.load()
	}
}

</script>

<style scoped>
.shadow-box {
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	height: 100%;
}

.label {
	margin-bottom: 10px;
}

section >>> .image {
	padding-bottom: 50%;
	margin-bottom: 5px;
}

a {
	margin: 0 auto;
	min-width: 170px;
	margin-top: auto;
	margin-bottom: 0;
	width: 100%;
}

.btn {
	width: 100%;
}
</style>
